import type { Palette } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import { FileText, House, ShoppingCart } from "lucide-react";
import type { PinKind } from "web_myplann/Portfolio/Components/Redesign/Detail/Pin/pinKind";

export type PinKindAppearance = {
	iconBg: string;
	iconColor: string;
	Icon: LucideIcon;
};

export const pinKindAppearance = (
	palette: Palette,
): Record<PinKind, PinKindAppearance> => ({
	contract: {
		iconBg: palette.blue[50],
		iconColor: palette.blue[600],
		Icon: FileText,
	},
	property: {
		iconBg: palette.green[50],
		iconColor: palette.green[600],
		Icon: House,
	},
	service: {
		iconBg: palette.amber[50],
		iconColor: palette.amber[600],
		Icon: ShoppingCart,
	},
	document: {
		iconBg: palette.grey[100],
		iconColor: palette.grey[500],
		Icon: FileText,
	},
});
